<template>
  <InputRadioGroup
    :legend="legend || 'Välj surfmängd'"
    :extra-legend="planText"
    type-class="product-page"
  >
    <InputRadioButton
      v-for="bundlePrice in familyStore.familyPlanBundlePricesToDisplay"
      :id="`family-plan-${bundlePrice.Plan?.PlanId}${bundlePrice.Plan?.PlanName}`"
      :key="`${bundlePrice.Plan?.PlanId}${bundlePrice.Plan?.PlanName}`"
      v-model="familyStore.selectedNewCustomerPlanId"
      :value="bundlePrice.Plan?.PlanId.toString()"
      group-name="family-plans"
    >
      <template #simple-label-replacement>
        <span
          v-if="
            bundlePrice.Plan?.RegularDataAllowance &&
            bundlePrice.Plan?.DataAllowance ===
              bundlePrice.Plan.RegularDataAllowance * 2
          "
          class="absolute top-[-10px] ms-8 md:ms-36 lg:ms-52 px-8 heading-xxs bg-surface-warning whitespace-nowrap"
        >
          Dubbel surf
        </span>
        <p
          class="heading-xs flex items-center"
          :aria-label="
            !!bundlePrice.Plan?.RegularDataAllowance
              ? `Ordinarie ${bundlePrice.Plan?.RegularDataAllowance} GB surf, nu ${bundlePrice.Plan?.DataAllowance} GB surf`
              : `${bundlePrice.Plan?.DataAllowance} GB surf`
          "
        >
          <span
            v-if="bundlePrice.Plan?.RegularDataAllowance"
            class="strike-through text-text-secondary me-8"
            aria-hidden="true"
          >
            {{ bundlePrice.Plan?.RegularDataAllowance }}
          </span>
          {{ bundlePrice.Plan?.DataAllowance }} GB
        </p>
      </template>
    </InputRadioButton>
  </InputRadioGroup>
</template>

<script lang="ts" setup>
interface Props {
  legend?: string;
}
defineProps<Props>();

const familyStore = useFamilyStore();

const planText = computed(() => {
  if (
    familyStore.selectedParentPlanBundlePrice?.Plan?.RegularMonthlyFee &&
    familyStore.selectedParentPlanBundlePrice?.Plan
      ?.OfferValidityInMonthsDiscount
  ) {
    return `${familyStore.selectedParentPlanBundlePrice?.Plan?.MonthlyFee.toLocaleString(
      'sv-SE',
    )} kr/mån i
    ${
      familyStore.selectedParentPlanBundlePrice?.Plan
        ?.OfferValidityInMonthsDiscount +
      ' mån därefter ' +
      familyStore.selectedParentPlanBundlePrice?.Plan?.RegularMonthlyFee +
      ' kr/mån'
    }`;
  }

  return `${familyStore.selectedParentPlanBundlePrice?.Plan?.MonthlyFee.toLocaleString(
    'sv-SE',
  )} kr/mån ${familyStore.selectedBindingPeriod === 0 ? '' : 'i ' + familyStore.selectedBindingPeriod + ' mån'}`;
});
</script>

<style scoped></style>
